webpackJsonp([35783957827783,156897593687669,263063586409284,70144966829960,263791100135453],{

/***/ "./node_modules/path-browserify/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ "./src/components/styledCover.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ScrollPrompt = exports.CoverParagraph = exports.CoverSubtitle = exports.CoverTitle = exports.CoverBackground = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    /** Flexbox container */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n\n    /** Mobile first */\n    padding-right: 0rem;\n    height: 100vh;\n    width: 100%;\n\n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        padding-right: 2rem;\n    }\n\n    text-align: end;\n    background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)),url(', ') no-repeat;\n    background-position: center;\n    background-size: cover;\n    /* background-attachment: fixed; */\n    color: ', ';\n'], ['\n    /** Flexbox container */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n\n    /** Mobile first */\n    padding-right: 0rem;\n    height: 100vh;\n    width: 100%;\n\n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        padding-right: 2rem;\n    }\n\n    text-align: end;\n    background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)),url(', ') no-repeat;\n    background-position: center;\n    background-size: cover;\n    /* background-attachment: fixed; */\n    color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    /** Mobile first */\n    font-size: 3rem;\n    max-width: 100%;\n    padding-right: 1rem;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 5rem;\n        max-width: 75%;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: \'Hammersmith One\', sans-serif;\n'], ['\n    /** Mobile first */\n    font-size: 3rem;\n    max-width: 100%;\n    padding-right: 1rem;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 5rem;\n        max-width: 75%;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: \'Hammersmith One\', sans-serif;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    /** Mobile first */\n    font-size: 2rem;\n    padding-right: 1rem;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 3rem;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: ', ';\n'], ['\n    /** Mobile first */\n    font-size: 2rem;\n    padding-right: 1rem;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 3rem;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    /** Mobile first */\n    font-size: 1.3rem;\n    padding-right: 1rem;\n    max-width: 90%;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 20px;\n        max-width: 50%;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: ', ';\n'], ['\n    /** Mobile first */\n    font-size: 1.3rem;\n    padding-right: 1rem;\n    max-width: 90%;\n    \n    /** Desktop */\n    @media only screen and (min-width: 768px) {\n        font-size: 20px;\n        max-width: 50%;\n        padding-right: 2rem;\n    }\n\n    color: ', ';\n    font-family: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: block;\n    overflow: hidden;\n    width: 60px;\n    height: 60px;\n    border: 2px solid;\n    border-radius: 50px;\n    background: url(', ') center no-repeat;\n    margin: 50px auto 50px auto;\n    box-shadow: ', ' 5px 5px 0px 0px;\n'], ['\n    display: block;\n    overflow: hidden;\n    width: 60px;\n    height: 60px;\n    border: 2px solid;\n    border-radius: 50px;\n    background: url(', ') center no-repeat;\n    margin: 50px auto 50px auto;\n    box-shadow: ', ' 5px 5px 0px 0px;\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _coding = __webpack_require__("./src/themes/coding.gif");
	
	var _coding2 = _interopRequireDefault(_coding);
	
	var _arrowDown = __webpack_require__("./src/themes/arrowDown.png");
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CoverBackground = _styledComponents2.default.header(_templateObject, function (props) {
	    return _coding2.default;
	}, function (props) {
	    return props.theme.light;
	});
	
	var CoverTitle = _styledComponents2.default.h1(_templateObject2, function (props) {
	    return props.theme.secondary;
	});
	
	var CoverSubtitle = _styledComponents2.default.h1(_templateObject3, function (props) {
	    return props.theme.light;
	}, function (props) {
	    return props.theme.font;
	});
	
	var CoverParagraph = _styledComponents2.default.p(_templateObject4, function (props) {
	    return props.theme.middle;
	}, function (props) {
	    return props.theme.font;
	});
	
	var ScrollPrompt = _styledComponents2.default.div(_templateObject5, function (props) {
	    return _arrowDown2.default;
	}, function (props) {
	    return props.theme.light;
	});
	
	exports.CoverBackground = CoverBackground;
	exports.CoverTitle = CoverTitle;
	exports.CoverSubtitle = CoverSubtitle;
	exports.CoverParagraph = CoverParagraph;
	exports.ScrollPrompt = ScrollPrompt;

/***/ }),

/***/ "./src/components/styledFooter.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FooterContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    color: ', ';\n    background-color: black;\n    padding: 10px 20px;\n    font-family: ', ';\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    color: ', ';\n    background-color: black;\n    padding: 10px 20px;\n    font-family: ', ';\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _noun_hamburger = __webpack_require__("./src/themes/noun_hamburger.svg");
	
	var _noun_hamburger2 = _interopRequireDefault(_noun_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FooterContainer = _styledComponents2.default.footer(_templateObject, function (props) {
	    return props.theme.light;
	}, function (props) {
	    return props.theme.font;
	});
	
	exports.FooterContainer = FooterContainer;

/***/ }),

/***/ "./src/layouts/aboutContainer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContainerLayout = function ContainerLayout(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "about" },
	        _react2.default.createElement(
	            _styledContainer.Title,
	            null,
	            props.title
	        ),
	        _react2.default.createElement(
	            _styledContainer.Container,
	            null,
	            _react2.default.createElement(
	                _styledContainer.TextContainer,
	                null,
	                props.children
	            ),
	            _react2.default.createElement(
	                _styledContainer.PersonalData,
	                null,
	                _react2.default.createElement(_styledContainer.ProfilePicture, null),
	                _react2.default.createElement(
	                    _styledContainer.Info,
	                    null,
	                    _react2.default.createElement(
	                        _styledContainer.LabelColumn,
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Name:\xA0"
	                            )
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Location:\xA0"
	                            )
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Phone:\xA0"
	                            )
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Email:\xA0"
	                            )
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Since:\xA0"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _styledContainer.DataColumn,
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            props.name
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            props.location
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            props.phone
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            props.email
	                        ),
	                        _react2.default.createElement(_styledContainer.RowSeparator, null),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            props.since
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ContainerLayout;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/layouts/container.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContainerLayout = function ContainerLayout(props) {
	    return _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	            _styledContainer.Container,
	            null,
	            _react2.default.createElement(
	                _styledContainer.TextContainer,
	                null,
	                props.children
	            )
	        )
	    );
	};
	
	exports.default = ContainerLayout;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/layouts/cover.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledCover = __webpack_require__("./src/components/styledCover.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cover = function Cover(props) {
	  return _react2.default.createElement(
	    _styledCover.CoverBackground,
	    null,
	    _react2.default.createElement(
	      _styledCover.CoverSubtitle,
	      null,
	      props.subtitle
	    ),
	    _react2.default.createElement(
	      _styledCover.CoverTitle,
	      null,
	      props.title
	    ),
	    _react2.default.createElement(
	      _styledCover.CoverParagraph,
	      null,
	      props.text
	    ),
	    _react2.default.createElement(_styledCover.ScrollPrompt, null)
	  );
	};
	
	exports.default = Cover;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/layouts/footer.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	var _styledFooter = __webpack_require__("./src/components/styledFooter.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    _styledFooter.FooterContainer,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: "left" } },
	      'Coded by ',
	      _react2.default.createElement(
	        _styledContainer.StyledLink,
	        { alt: 'GitHub profile', target: '_blank', href: 'https://github.com/davosolo' },
	        'David Mu\xF1oz'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: "right" } },
	      'About ',
	      _react2.default.createElement(
	        _styledContainer.StyledLink,
	        { alt: 'This website source code', target: '_blank', href: 'https://github.com/davosolo/davosolo.github.io' },
	        'this'
	      ),
	      ' website'
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/about.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__("./src/layouts/header.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _aboutContainer = __webpack_require__("./src/layouts/aboutContainer.js");
	
	var _aboutContainer2 = _interopRequireDefault(_aboutContainer);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    _aboutContainer2.default,
	    { title: 'ABOUT ME', subtitle: '[~]$ whoami', name: 'David Mu\xF1oz Mar\xEDn', phone: '(+57) 311 394 1014', email: 'davidmzm@gmail.com', location: 'Medell\xEDn, Colombia', since: 'March 25th, 1984' },
	    _react2.default.createElement(
	      _styledContainer.Subtitle,
	      null,
	      '[~]$ whoami'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'m a B.S in Computer Science experienced in software development towards the front-end side, skilled in a wide variety of technologies. Throughout my career I\'ve gained expertise in all aspects of the software development life cycle, in both: agile & waterfall methodologies.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      _styledContainer.Subtitle,
	      null,
	      'What I like'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I enjoy creating stuff, especially if I can use the latest trends of this never ending changing world of software development. Even though I\'ve worked before as a back-end developer, nowadays I\'m more into coding the presentation layer of the web applications. Also, I\'ve been playing with hybrid mobile applications frameworks like Ionic and Fuse lately and I find it fascinating. Now... Stepping aside from software, I like running, watching movies & TV shows, videogames and of course, music. Photographer wannabe.'
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__("./src/layouts/container.js");
	
	var _container2 = _interopRequireDefault(_container);
	
	var _banner = __webpack_require__("./src/layouts/banner.js");
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    _banner2.default,
	    {
	      id: 'contact',
	      title: 'CONTACT',
	      backgroundImage: null,
	      attachment: 'scroll',
	      height: '410px'
	    },
	    _react2.default.createElement(
	      _styledContainer.StrongContainer,
	      null,
	      _react2.default.createElement(
	        _styledContainer.IconsContainer,
	        null,
	        _react2.default.createElement(
	          _styledContainer.StyledLink,
	          { alt: 'E-mail', href: 'mailto:davidmzm@gmail.com' },
	          _react2.default.createElement(_styledContainer.EmailIcon, null)
	        ),
	        _react2.default.createElement(
	          _styledContainer.StyledLink,
	          { alt: 'LinkedIn', target: '_blank', href: 'https://www.linkedin.com/in/david-mu%C3%B1oz-mar%C3%ADn-8785815/' },
	          _react2.default.createElement(_styledContainer.LinkedinIcon, null)
	        ),
	        _react2.default.createElement(
	          _styledContainer.StyledLink,
	          { alt: 'GitHub', target: '_blank', href: 'https://github.com/davosolo' },
	          _react2.default.createElement(_styledContainer.GithubIcon, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cover = __webpack_require__("./src/layouts/cover.js");
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _header = __webpack_require__("./src/layouts/header.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__("./src/layouts/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _about = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/about.js");
	
	var _about2 = _interopRequireDefault(_about);
	
	var _contact = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact.js");
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _resume = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/resume.js");
	
	var _resume2 = _interopRequireDefault(_resume);
	
	var _skills = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/skills.js");
	
	var _skills2 = _interopRequireDefault(_skills);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    { id: 'home' },
	    _react2.default.createElement(_cover2.default, {
	      title: 'FRONT-END DEVELOPER',
	      subtitle: 'Mu\xF1oz, David',
	      text: 'Hey... Welcome! Here, you can take a glance of everything that has to do with me and my work so you can have a better idea of what I\'m able to do. Or in other words: showing off.'
	    }),
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(_about2.default, null),
	    _react2.default.createElement(_resume2.default, null),
	    _react2.default.createElement(_skills2.default, null),
	    _react2.default.createElement(_contact2.default, null),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/resume.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__("./src/layouts/banner.js");
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _workers = __webpack_require__("./src/themes/workers.jpeg");
	
	var _workers2 = _interopRequireDefault(_workers);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = __webpack_require__("./node_modules/path-browserify/index.js");
	
	var ResumePage = function ResumePage() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'resume' },
	        _react2.default.createElement(_banner2.default, {
	            title: 'RESUME',
	            backgroundImage: _workers2.default,
	            attachment: 'fixed',
	            height: '310px'
	        }),
	        _react2.default.createElement(
	            _styledContainer.StrongContainer,
	            null,
	            _react2.default.createElement(
	                _styledContainer.TextContainer,
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Just hit the button below...'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _styledContainer.StyledButton,
	                    { target: '_blank', href: path.resolve(("/davosolo.github.io") + '/static/DavidMunoz_Resume.pdf') },
	                    'Download'
	                )
	            )
	        )
	    );
	};
	
	exports.default = ResumePage;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/david/Sites/davosolo.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/david/Sites/davosolo.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/skills.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Medellin = __webpack_require__("./src/themes/Medellin.jpg");
	
	var _Medellin2 = _interopRequireDefault(_Medellin);
	
	var _banner = __webpack_require__("./src/layouts/banner.js");
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _styledContainer = __webpack_require__("./src/components/styledContainer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkillsPage = function SkillsPage() {
	  return _react2.default.createElement(
	    _banner2.default,
	    {
	      id: 'skills',
	      title: 'SKILLS',
	      backgroundImage: _Medellin2.default,
	      attachment: 'scroll',
	      height: '800px'
	    },
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'HTML5'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "1rem" } },
	        'PostgreSQL'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "2rem" } },
	        'TypeScript'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'Gatsby'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "2rem" } },
	        'Ionic'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'JavaScript'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'SASS'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'jQuery'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'Git'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'StyledComponents'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'MySQL'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'Gulp'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "1rem" } },
	        'Firebase'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'CSS3'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "1rem" } },
	        'Fuse'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'React'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "2rem" } },
	        'Bootstrap'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "4rem" } },
	        'PHP'
	      )
	    ),
	    _react2.default.createElement(
	      _styledContainer.CloudRow,
	      null,
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "2rem" } },
	        'Angular2'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "3rem" } },
	        'RESTful WS'
	      ),
	      _react2.default.createElement(
	        _styledContainer.CloudItem,
	        { style: { fontSize: "1rem" } },
	        'MongoDB'
	      )
	    )
	  );
	};
	
	exports.default = SkillsPage;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/themes/Medellin.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Medellin.6c9bd220.jpg";

/***/ }),

/***/ "./src/themes/arrowDown.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAASCAYAAACnxdXaAAAAt0lEQVRIibXV2xHCIBBG4V87oAVboAV7shZrMSXYQlqwheODZCYXAruAZ4YHMpn94AkBAiLwAELaj14hzY+AFvDDr/cf4JDmkpwoYGbbSHgNLs1XSZO2RUkvSUF9hTQn7r5Py4meHOu5ce6GJEfrH0fBRXCPjoCrYA7tgU3gGdoCm8ES6oFdYA21wG7QgpbgWwtoRc/gXFXQg1pgE+hFS7AZbEFzsAtsRdewGwR0AVpfkbuOL5SpL1Px+TGJARuIAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./src/themes/coding.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coding.996ecc19.gif";

/***/ }),

/***/ "./src/themes/workers.jpeg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/workers.c7f8373f.jpeg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-049b904566423790f723.js